
<div :class="jel_getClassObject(content)" class="m-1">
  <div class="bloc-mise-avant w-100">
    <div class="bloc-mise-avant-contenu d-block h-100">
      <span class="type-bloc">{{ $tc(`messageComponent.${content.type.field}`) }}</span>
      <span class="texte-bloc pt-1" v-html="contenu" />
      <button class="bouton" @click="ouvertureZoneEscamotable()">
        {{
          content.type.field === 'section'
            ? $tc('messageComponent.voirQuestions')
            : $tc('messageComponent.voirReponse')
        }}
      </button>
    </div>
  </div>
</div>
